<template>
  <div
    class="tab-pane fade active show"
    id="profile"
    role="tabpanel"
    aria-labelledby="profile-tab"
  >
    <div class="card-body">
      <!-- Form -->
      <div class="row text-center">
        <div class="col-md-6 form-group mb-3">
          <label>Name</label>
          <input class="form-control" v-model="profile.full_name" />
        </div>

        <div class="col-md-6 form-group mb-3">
          <label>Email</label>
          <input class="form-control" v-model="profile.email" />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>IC No.</label>
          <input class="form-control" v-model="profile.ic_number" />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>New IC No.</label>
          <input class="form-control" v-model="new_ic_number" />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Date of Birth</label>
          <input type="date" class="form-control" v-model="profile.date_of_birth" />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Gender</label>
          <select v-model="profile.gender" class="form-control">
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Marital Status</label>
          <select v-model="profile.marital_status" class="form-control">
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Widow/Widower">Widow/Widower</option>
            <option value="Divorcee">Divorcee</option>
            <option value="N/A">N/A</option>
          </select>
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Nationality</label>
          <select v-model="profile.nationality" class="form-control">
            <option
              v-for="(nationality, i) in nationalities"
              :key="i"
              :value="nationality"
              >{{ nationality }}</option
            >
          </select>
        </div>

        <!-- <div class="col-md-3 form-group mb-3">
          <label>Race</label>
          <input class="form-control" v-model="profile.race.name">
        </div>-->

        <div class="col-md-3 form-group mb-3">
          <label>Religion</label>
          <select v-model="profile.religion" class="form-control">
            <option value="Muslim">Muslim</option>
            <option value="Non-Muslim">Non-Muslim</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Mobile No.</label>
          <input class="form-control" v-model="profile.mobile_number" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 form-group mb-3">
          <label>Kampong</label>
          <select class="form-control" @change="onSelectKampong">
            <option
              v-for="(kampong, i) in kampongs"
              :key="i"
              :value="JSON.stringify(kampong)"
              :selected="kampong.name === profile.kampong"
              >{{ kampong.name }}</option
            >
          </select>
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Postal Code</label>
          <input class="form-control" v-model="profile.postal_code" disabled />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Occupation</label>
          <input class="form-control" v-model="profile.occupation" />
        </div>

        <div class="col-md-3 form-group mb-3">
          <label>Office Address</label>
          <input class="form-control" v-model="profile.office_address" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 form-group mb-3">
          <label>Address 1</label>
          <input class="form-control" v-model="profile.address1" />
        </div>

        <div class="col-md-4 form-group mb-3">
          <label>Address 2</label>
          <input class="form-control" v-model="profile.address2" />
        </div>

        <div class="col-md-4 form-group mb-3">
          <label>Address 3</label>
          <input class="form-control" v-model="profile.address3" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group mb-3">
          <label>Registration Date</label>
          <input class="form-control" v-model="profile.created_at" />
        </div>

        <div class="col-md-6 form-group mb-3">
          <label>Verified At</label>
          <input class="form-control" v-model="profile.email_verified_at" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group mb-3">
          <label>Declined Reason</label>
          <input class="form-control" v-model="profile.declined_reason" />
        </div>

        <div class="col-md-6 form-group mb-3">
          <label>Declined At</label>
          <input class="form-control" v-model="profile.declined_at" disabled />
        </div>
      </div>

      <!-- Button -->
      <div class="text-center">
        <button
          @click="update_customer()"
          class="btn btn-rounded btn-primary"
          style="width: 100px;"
        >
          Update
        </button>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle-2"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle-2">
              Change Mobile Number
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col form-group mb-3">
              <label>New Mobile Number</label>
              <input class="form-control" type="tel" required />
            </div>
            <div class="col form-group mb-3">
              <label>Reason</label>
              <textarea class="form-control" required />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";

export default {
  name: "customer_profile",
  components: {},
  props: ["profile"],
  update: [],
  data() {
    return {
      customer_id: this.$route.params.id,
      new_ic_number: "",
      nationalities: [],
      kampongs: [],
      token: null,
      headers: {}
    };
  },

  methods: {
    loadToken() {
      let token = localStorage.getItem("token");
      token = JSON.parse(token);
      this.token = token.access_token;
      this.headers = {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      };
    },
    onSelectKampong(e) {
      const kampong = JSON.parse(e.target.value);
      this.profile.kampong = kampong.name;
      this.profile.postal_code = kampong.post_code;
    },
    async loadLovs() {
      if (this.token === null) {
        return false;
      }

      const url = axios.baseURL2 + "/customer/lov";

      const { data } = await axios.get(url, this.headers);
      const { nationalities, kampongs } = data;
      this.kampongs = kampongs;
      this.nationalities = nationalities.map(nationality => nationality.value);
    },
    async update_customer() {
      if (this.token === null) {
        return;
      }

      const confirm = await swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      });

      if (!confirm) {
        swal({
          icon: "info",
          text: "Cancelled!"
        });
        return false;
      }

      const url = "/customers/update";

      if (this.new_ic_number !== "") {
        this.profile["new_ic_number"] = this.new_ic_number;
      }

      const { data } = await axios.post(url, this.profile, this.headers);
      const { success, message } = data;

      if (!success) {
        swal({
          icon: "error",
          text: message
        });
        return false;
      }

      swal({
        icon: "success",
        text: message
      });
      this.$router.push("/customers");
    }
  },

  mounted() {
    this.loadToken();
    this.loadLovs();
  }
};
</script>
